import { render, staticRenderFns } from "./customerExclude.vue?vue&type=template&id=6fdf0c8a&scoped=true&"
import script from "./customerExclude.vue?vue&type=script&lang=js&"
export * from "./customerExclude.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdf0c8a",
  null
  
)

export default component.exports